require('./cardModifyDebitLimitsView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
// @ actions
const cardModifyDebitLimitsActions = require('actions/cardModifyDebitLimits');
// @ components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const ModifyDebitLimitsStep1 = require('components/cards/cardModifyDebitLimits/modifyDebitLimitsStep1/modifyDebitLimitsStep1');
const ModifyDebitLimitsStep2 = require('components/cards/cardModifyDebitLimits/modifyDebitLimitsStep2/modifyDebitLimitsStep2');
const ModifyDebitLimitsSuccessStep = require('components/cards/cardModifyDebitLimits/modifyDebitLimitsSuccessStep/modifyDebitLimitsSuccessStep');
const ModifyDebitLimitsErrorStep = require('components/cards/cardModifyDebitLimits/modifyDebitLimitsErrorStep/modifyDebitLimitsErrorStep');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
// @ utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const {
    PROC_MODIFY_DEBIT_LIMITS_EXTRACT,
    PROC_MODIFY_DEBIT_LIMITS_COMMERCE,
} = require('utilities/tagging');
// @ constants
const { GRAPHIC_TUTOR_TYPE_4, CARD_MODIFY_DEBIT_LIMITS_TYPE_COMMERCE, CARD_MODIFY_DEBIT_LIMITS_TYPE_EXTRACT } = require('constants/index');

class CardModifyDebitLimitsView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId, type } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_MODIFY_DEBIT_LIMITS, { immCard }, history);

        if (type === 'commerce') {
            this.props.requestLimits(cardId, CARD_MODIFY_DEBIT_LIMITS_TYPE_COMMERCE);
        } else if (type === 'extract') {
            this.props.requestLimits(cardId, CARD_MODIFY_DEBIT_LIMITS_TYPE_EXTRACT);
        } else {
            this.props.history.push(`/myprofile/cards/${cardId}/details`);
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    handleCancel() {
        const { cardId } = this.props.match.params;
        this.props.history.push(`/myprofile/cards/${cardId}/details`);
    }

    handleFinish() {
        const { cardId } = this.props.match.params;
        this.props.modifyDebitLimits(cardId);
    }

    buildHeader(immCard) {
        const { match: { params: { type } } } = this.props;

        const titleKey = type === 'commerce' ? 'cardModifyDebitLimits-commerceTitle' : 'cardModifyDebitLimits-extractTitle';

        const cardType = immCard.get('type');
        const subtitleLeft = formatText(`cards-${cardType}`);
        const subtitleRight = immCard.get('alias').get('current');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${this.props.match.params.cardId}/movements`
            },
            {
                text: formatText('cardDetails-limitLink')
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-cardsModifyDebitLimitsTitle')}
            />
        );
        return (
            <OKCover size="medium" section="cards" customClass="col-xs-12">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    subtitleLeft={subtitleLeft}
                    subtitleRight={subtitleRight}
                    tutorial={tutorial}
                    finalTitle={getFinalTitle(titleKey)}>
                </OKHeaderSubPage>
            </OKCover>
        );
    }

    buildWizard(immCard) {
        const {
            immCardModifyDebitLimits,
            validateStep,
            setVisibleStep,
            setWillCancel,
            handleLimitChange,
            match: { params: { type } },
        } = this.props;
        const processType = type === 'commerce' ? PROC_MODIFY_DEBIT_LIMITS_COMMERCE : PROC_MODIFY_DEBIT_LIMITS_EXTRACT;
        const immSteps = immCardModifyDebitLimits.get('steps');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };

        const wizard = (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                processType={processType}
                stepsAmount={immSteps.size}
                visibleStep={immCardModifyDebitLimits.get('visibleStep')}
                showPreLeaveModal={true}
            >
                <WizardStep position="first" cancelButton={true} >
                    <ModifyDebitLimitsStep1
                        immCard={immCard}
                        immCardModifyDebitLimits={immCardModifyDebitLimits}
                        handleLimitChange={handleLimitChange}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton="common-confirm"
                    isLoading={immCardModifyDebitLimits.get('isLoading')}
                >
                    <ModifyDebitLimitsStep2
                        immCard={immCard}
                        immCardModifyDebitLimits={immCardModifyDebitLimits}
                    />
                </WizardStep>
            </Wizard>
        );

        return (
            <div className="col-xs-12">
                {wizard}
            </div>
        );
    }

    render() {
        const { match: { params: { cardId, type } }, immCards, immCardModifyDebitLimits } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const processType = type === 'commerce' ? PROC_MODIFY_DEBIT_LIMITS_COMMERCE : PROC_MODIFY_DEBIT_LIMITS_EXTRACT;

        let header;
        let bodyContent;

        if (immCard) {
            header = this.buildHeader(immCard);

            if (immCardModifyDebitLimits.get('isFetching')) {
                bodyContent = (
                    <div className="col-xs-12">
                        <OKSectionBox>
                            <LoadingSection />
                        </OKSectionBox>
                    </div>
                );
            }
            else if (immCardModifyDebitLimits.get('error')) {
                bodyContent = (
                    <ModifyDebitLimitsErrorStep
                        immCard={immCard}
                        immCardModifyDebitLimits={immCardModifyDebitLimits}
                        processType={processType}
                    />
                );
            } else if (immCardModifyDebitLimits.get('submitSuccessful')) {
                bodyContent = (
                    <ModifyDebitLimitsSuccessStep
                        immCard={immCard}
                        immCardModifyDebitLimits={immCardModifyDebitLimits}
                        processType={processType}
                    />
                );
            } else if (immCardModifyDebitLimits.get('fetchSuccess')) {
                bodyContent = this.buildWizard(immCard);
            }
        }

        return (
            <div>
                <div className="container-fluid card-movements--header-identifier">
                    <div className="row">
                        {header}
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {bodyContent}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardModifyDebitLimitsView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardModifyDebitLimits: PropTypes.object.isRequired,
    requestLimits: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    handleLimitChange: PropTypes.func,
    modifyDebitLimits: PropTypes.func.isRequired,
};

module.exports.constructor = CardModifyDebitLimitsView;
module.exports.CardModifyDebitLimitsView = connect(
    (state) => ({
        immCards: state.cards,
        immCardModifyDebitLimits: state.cardModifyDebitLimits
    }), {
    requestLimits: cardModifyDebitLimitsActions.requestLimits,
    validateStep: cardModifyDebitLimitsActions.validateStep,
    setVisibleStep: cardModifyDebitLimitsActions.setVisibleStep,
    setWillCancel: cardModifyDebitLimitsActions.setWillCancel,
    modifyDebitLimits: cardModifyDebitLimitsActions.modifyDebitLimits,
    reset: cardModifyDebitLimitsActions.reset,
    handleLimitChange: cardModifyDebitLimitsActions.setLimit,
})(withRouter(CardModifyDebitLimitsView));
